import { TestImage } from "@assets/constant/index.constant";
import { endpoint } from "@services/api.services";
import { GeneralCard, TableCard } from "@ui/internal/components/card";
import { getTableInfo } from "@utils/helper/index.helper";
import { useHandleAction, usePathname } from "@utils/hook/index.hook";
import { QueryData } from "@utils/interface/index.interface";
import { BrandingData } from "@utils/interface/journey.interface";
import { useListData } from "@utils/query/index.query";
import { useMetaStore, useSelectionStore } from "@utils/states/index.state";
import { format } from "date-fns";
import { useNavigate, useParams, useSearchParams } from "react-router";
import BrandingForm from "../../form/branding.form";
import { ChevronLeft } from "lucide-react";

const index = () => {
  const params = useParams();
  const result = getTableInfo({
    mode: "default",
    type: params.id || "",
  }) as { title: string; description: string };
  console.log("params.id", params.id);
  let { title, description } = result;
  const { search, date } = useMetaStore();
  const pathname = usePathname();
  const [searchParams] = useSearchParams();
  const { selectedRows } = useSelectionStore();
  const navigate = useNavigate();
  const { data, isPending, refetch } = useListData<QueryData<BrandingData>>({
    params: {
      branding: params.id,
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      test: "ok",
      search,
      created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
      created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
      ordering: searchParams.get("ordering") || "order",
    },

    endpoint: endpoint["branding"],
    key: `${pathname}-listing`,
    window: true,
  });

  return (
    <>
      <ChevronLeft
        className="cursor-pointer relative z-9999 translate-y-18"
        onClick={() => {
          navigate("/certificate/branding");
        }}
      />
      {/* <div className="  gap-10">
        <div className="flex gap-2 justify-between items-center">
          {" "}
          <div className="flex gap-2 items-center">
            {" "}
            <ChevronLeft
              className="cursor-pointer"
              onClick={() => {
                navigate("/certificate/branding");
              }}
            />
            <ul className="list-none">
              {<li className="text-[32px] font-[500]">{title}</li>}
              {<li className="text-[#7B7679] text-[14px]">{description}</li>}
            </ul>
          </div>
          {selectedRows && (
            <Button variant={"destructive"}>
              Delete {`(${selectedRows.length})`}
            </Button>
          )}
          <Button
            onClick={() => {
              handleAction({
                type: "modal-add",
              });
            }}
          >
            Add {title}
          </Button>
        </div>

        {isPending ? (
          <GridCardSkeleton />
        ) : data && data.data.results.length > 0 ? (
          <div className="grid my-10 grid-cols-1 md:grid-cols-2 p-4 lg:grid-cols-3 gap-y-[20px] md:gap-x-[20px]">
            {data?.data?.results.map((item, index) => (
              <GeneralCard
                key={index}
                showCheck
                isChecked={false}
                type={"branding"}
                onDelete={() => {}}
                onEdit={() => {}}
                item={item}
              />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-[50vh]">
            {" "}
            <Empty
              position="center"
              image="/assets/images/cameralooking.png"
              title={title}
              description={description}
            >
              <Button
                onClick={() =>
                  handleAction({
                    type: "modal-add",
                  })
                }
                className="capitalize"
              >
                Add{" "}
                {(searchParams.get("search") &&
                  `"${searchParams.get("search")}" in`) ||
                  ""}{" "}
                {title}
              </Button>
            </Empty>
          </div>
        )}

        <div className="my-10">
          <PaginationFooter
            action={() => {}}
            total={data?.data?.count || 0}
            value={{
              page: Number(searchParams.get("page")) || 1,
              per: Number(searchParams.get("per")) || 10,
            }}
            showPerPage
          />
        </div>
      </div>
      <Dialog
        className={cn(["lg:min-w-[400px]  lg:max-w-auto max-w-[330px]"])}
        open={
          searchParams.get("modal") || searchParams.get("confirm")
            ? true
            : false
        }
        title={`${
          searchParams.get("modal") || "Are you sure you want to remove the"
        } ${params?.id ?? pathname?.replace("-", " ")} ${
          searchParams.get("confirm") ? "?" : ""
        }`}
        description={
          searchParams.get("confirm")
            ? `Selected ${pathname?.replace(
                "-",
                " "
              )} will be removed permanently. Do you want to remove it anyway?`
            : `Manage Skillshikshya ${
                params?.id ?? pathname?.replace("-", " ")
              } here.`
        }
        setOpen={() =>
          handleAction({
            type: searchParams.get("confirm") ? "confirm-close" : "modal-close",
          })
        }
      >
        <div className="h-[500px] overflow-auto">
          {searchParams.get("confirm") ? (
            <ActionConfirmButton
              isPending={deletePending || isPending}
              onDelete={() => {
                handleAction({
                  type: "delete",
                  data: ["bulk"].includes(searchParams.get("confirm") || "")
                    ? selectedRows
                    : searchParams.get("confirm-item"),
                });
              }}
              onCancel={() => {
                handleAction({ type: "confirm-close" });
              }}
            />
          ) : (
            <BrandingForm refetch={() => {}} />
          )}
        </div>
      </Dialog> */}
      <TableCard
        bulkActions
        table_content={{
          mode: "default",
          type: params.id as string,
        }}
        isPending={isPending}
        // showOrientationSecond
        // sortableFilter={{
        //   search,
        //   created_date__gte: date.from ? formatDate(date.from) : "",
        //   created_date__lte: date.to ? formatDate(date.to) : "",
        //   ordering: searchParams.get("ordering") || "order",
        //   team_member__id__in:
        //     searchParams.get("success-story-team-members") || "",
        //   student__id__in: searchParams.get("success-story-studnet") || "",
        //   status:
        //     searchParams
        //       .get("data-category")
        //       ?.toLocaleLowerCase()
        //       ?.split("-")[0] === "published"
        //       ? ""
        //       : searchParams
        //           .get("data-category")
        //           ?.toLocaleLowerCase()
        //           ?.split("-")[0] || "",
        // }}

        grid={
          <GeneralCard
            isChecked={false}
            showCheck
            type={"branding"}
            content={{
              username: "Yunika Shakya",
              userdesignation: "UI/UX Designer",
              userimage: TestImage || "",
              description:
                "Digital Marketing Mentorgital Marketing Mentorgital Marketing Mentor",
            }}
            onDelete={() => {}}
            onEdit={() => {}}
          />
        }
        orientationPosition
        columns={[]}
        form={<BrandingForm refetch={() => {}} />}
        endpoint={endpoint["branding"]}
        refetch={refetch}
        rows={data?.data?.results ?? []}
        count={data?.data?.count ?? 10}
      />
    </>
  );
};

export default index;
